import React from 'react'
import { ReactComponent as LoadingImg } from '../../../assets/images/loading.svg'

export const FullscreenLoading = () => (
  <div className="main-loading">
    <LoadingImg />
  </div>
)
